import { createReducer, on } from '@ngrx/store';

import * as CriminalRecordCheckActions from './criminal-record-check.actions';
import {
  CriminalRecordCheckState,
  initialCriminalRecordCheckState,
} from './criminal-record-check.state';

const criminalRecordCheckReducer = createReducer<CriminalRecordCheckState>(
  initialCriminalRecordCheckState,
  on(
    CriminalRecordCheckActions.createCriminalRecordCheckDocumentSuccess,
    (state, { criminalRecordCheckDocument }) => ({
      ...state,
      criminalRecordCheckDocument,
    })
  ),
  on(
    CriminalRecordCheckActions.fetchLatestCriminalRecordCheckDocumentSuccess,
    (state, { criminalRecordCheckDocument }) => ({
      ...state,
      criminalRecordCheckDocument,
      fetchedAt: new Date(),
    })
  ),
  on(
    CriminalRecordCheckActions.updateCriminalRecordCheckDocumentSuccess,
    (state, { criminalRecordCheckDocument }) => ({
      ...state,
      criminalRecordCheckDocument,
    })
  ),
  on(
    CriminalRecordCheckActions.deleteCriminalRecordCheckDocumentSuccess,
    (state, { id }) => ({
      ...state,
      criminalRecordCheck: null,
    })
  ),
  on(
    CriminalRecordCheckActions.fetchLatestCriminalRecordCheckDocumentFailed,
    (state, { error }) => ({
      ...state,
      fetchedAt: new Date(),
    })
  )
);

export { criminalRecordCheckReducer };
